import { fetchApi, ADMIN_API } from '@/api/client'
import type { BulkApiTraceResponse, BulkApiTraceRow, EventFileTraceRow, EventTraceResponse } from '../types'

const BASE = `${ADMIN_API}/pipeline`

export async function getEventTrace(params: {
  accId: number
  limit?: number
  category?: string
  eventName?: string
}): Promise<EventTraceResponse> {
  const query = new URLSearchParams()
  query.set('accId', String(params.accId))
  query.set('limit', String(params.limit ?? 100))
  if (params.category) query.set('category', params.category)
  if (params.eventName) query.set('eventName', params.eventName)
  return fetchApi<EventTraceResponse>(`${BASE}/trace/events?${query}`)
}

export async function getBulkApiTrace(params: {
  accId: number
  limit?: number
}): Promise<BulkApiTraceResponse> {
  const query = new URLSearchParams()
  query.set('accId', String(params.accId))
  query.set('limit', String(params.limit ?? 100))
  return fetchApi<BulkApiTraceResponse>(`${BASE}/trace/bulk-api?${query}`)
}

/** Fires the StarRocks/warehouse count queries for one event file (explicit user action). */
export async function syncEventFile(params: { accId: number; fileId: string }): Promise<EventFileTraceRow> {
  const query = new URLSearchParams()
  query.set('accId', String(params.accId))
  return fetchApi<EventFileTraceRow>(`${BASE}/trace/events/${params.fileId}/sync?${query}`, { method: 'POST' })
}

/** Fires the StarRocks/warehouse count queries for one bulk API call (explicit user action). */
export async function syncBulkApiCall(params: { accId: number; requestId: string }): Promise<BulkApiTraceRow> {
  const query = new URLSearchParams()
  query.set('accId', String(params.accId))
  return fetchApi<BulkApiTraceRow>(`${BASE}/trace/bulk-api/${params.requestId}/sync?${query}`, { method: 'POST' })
}
